module.exports = "https://static.wagwalking.com/_next/static/images/sitting-b2a9aa0408ee5ff85147abd682ce0702.svg";